import React from "react";

type AuthenticatedActionsProps = {
  isVisible: boolean;
  buttonWidth: string;
  disabled: boolean;
  errorMsg: string;
  onSubmit: () => void;
  loading: boolean;
  buttonLabel: string;
};

function DemoAuthenticatedActions({
  isVisible,
  buttonWidth,
  disabled,
  errorMsg,
  onSubmit,
  loading,
  buttonLabel,
}: AuthenticatedActionsProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="w-full animate-fade-in tablet:pl-[86px] main:w-[min(734px,90%)] main:pl-[138px]">
      <div className="flex items-start gap-5">
        <div className="flex w-full flex-col">
          <button
            id="construct-agent"
            disabled={disabled}
            onClick={onSubmit}
            className="flex h-[60px] items-center justify-center gap-[11px] rounded-md bg-primary px-4 text-xl font-semibold text-white transition-all disabled:bg-gray-300"
            style={{ width: buttonWidth }}
          >
            {loading && <span className="loader-medium"></span>}
            <span>{buttonLabel}</span>
          </button>
          {errorMsg && (
            <div className="text-xl font-light text-red-700">{errorMsg}</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DemoAuthenticatedActions;
